(function () {
  function setStackHeights() {
    var header = document.querySelector('.section-header');
    var announcement = document.querySelector('.announcement-bar-section');
    if (header) {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
    if (announcement) {
      document.documentElement.style.setProperty('--announcement-height', announcement.offsetHeight + 'px');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setStackHeights);
  } else {
    setStackHeights();
  }

  window.addEventListener('load', setStackHeights);
  window.addEventListener('resize', setStackHeights);

  if (typeof ResizeObserver === 'function') {
    var header = document.querySelector('.section-header');
    var announcement = document.querySelector('.announcement-bar-section');
    if (header) {
      new ResizeObserver(setStackHeights).observe(header);
    }
    if (announcement) {
      new ResizeObserver(setStackHeights).observe(announcement);
    }
  }

  function syncMenuOpenClass() {
    var header = document.querySelector('.section-header');
    document.documentElement.classList.toggle(
      'ragavi-menu-open',
      !!(header && header.classList.contains('menu-open'))
    );
  }

  function bindMenuOpenLock() {
    var header = document.querySelector('.section-header');
    if (!header || typeof MutationObserver === 'undefined') return;
    syncMenuOpenClass();
    new MutationObserver(syncMenuOpenClass).observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindMenuOpenLock);
  } else {
    bindMenuOpenLock();
  }
})();
